import { render } from "./PlanificareAnuala.vue?vue&type=template&id=180d5b17&ts=true"
import script from "./PlanificareAnuala.vue?vue&type=script&lang=ts"
export * from "./PlanificareAnuala.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__